module.exports = __webpack_public_path__ + "img/raw7.ed9b2ea2.png";